import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';
import { Helmet } from 'react-helmet-async';
import { getGeoLocation, handleFormSubmission } from '../services/apiService';

const countryCodes = [
  { code: '+1', country: 'US' },
  { code: '+44', country: 'UK' },
  { code: '+91', country: 'IN' },
  { code: '+61', country: 'AU' },
  { code: '+86', country: 'CN' },
  { code: '+81', country: 'JP' },
  { code: '+49', country: 'DE' },
  { code: '+33', country: 'FR' },
  { code: '+39', country: 'IT' },
  { code: '+34', country: 'ES' },
  { code: '+55', country: 'BR' },
  { code: '+52', country: 'MX' },
  { code: '+7', country: 'RU' },
  { code: '+82', country: 'KR' },
  { code: '+27', country: 'ZA' },
  { code: '+31', country: 'NL' },
  { code: '+41', country: 'CH' },
  { code: '+46', country: 'SE' },
  { code: '+47', country: 'NO' },
  { code: '+358', country: 'FI' },
  { code: '+45', country: 'DK' },
  { code: '+43', country: 'AT' },
  { code: '+32', country: 'BE' },
  { code: '+351', country: 'PT' },
  { code: '+353', country: 'IE' },
  { code: '+352', country: 'LU' },
  { code: '+358', country: 'IS' },
  { code: '+370', country: 'LT' },
  { code: '+371', country: 'LV' },
  { code: '+372', country: 'EE' },
  { code: '+48', country: 'PL' },
  { code: '+420', country: 'CZ' },
  { code: '+421', country: 'SK' },
  { code: '+36', country: 'HU' },
  { code: '+40', country: 'RO' },
  { code: '+359', country: 'BG' },
  { code: '+381', country: 'RS' },
  { code: '+385', country: 'HR' },
  { code: '+386', country: 'SI' },
  { code: '+387', country: 'BA' },
  { code: '+389', country: 'MK' },
  { code: '+380', country: 'UA' },
  { code: '+995', country: 'GE' },
  { code: '+994', country: 'AZ' },
  { code: '+374', country: 'AM' },
  { code: '+373', country: 'MD' },
  { code: '+998', country: 'UZ' },
  { code: '+996', country: 'KG' },
  { code: '+993', country: 'TM' },
  { code: '+992', country: 'TJ' },
  { code: '+7', country: 'KZ' },
  { code: '+93', country: 'AF' },
  { code: '+92', country: 'PK' },
  { code: '+94', country: 'LK' },
  { code: '+880', country: 'BD' },
  { code: '+977', country: 'NP' },
  { code: '+966', country: 'SA' },
  { code: '+971', country: 'AE' },
  { code: '+968', country: 'OM' },
  { code: '+974', country: 'QA' },
  { code: '+973', country: 'BH' },
  { code: '+965', country: 'KW' },
  { code: '+20', country: 'EG' },
  { code: '+27', country: 'ZA' },
  { code: '+234', country: 'NG' },
  { code: '+254', country: 'KE' },
  { code: '+233', country: 'GH' },
  { code: '+237', country: 'CM' },
  { code: '+225', country: 'CI' },
  { code: '+221', country: 'SN' },
  { code: '+213', country: 'DZ' },
  { code: '+212', country: 'MA' },
  { code: '+216', country: 'TN' },
  { code: '+218', country: 'LY' },
  { code: '+972', country: 'IL' },
  { code: '+964', country: 'IQ' },
  { code: '+962', country: 'JO' },
  { code: '+961', country: 'LB' },
  { code: '+970', country: 'PS' },
  { code: '+90', country: 'TR' },
  { code: '+98', country: 'IR' },
  { code: '+60', country: 'MY' },
  { code: '+65', country: 'SG' },
  { code: '+62', country: 'ID' },
  { code: '+63', country: 'PH' },
  { code: '+66', country: 'TH' },
  { code: '+84', country: 'VN' },
  { code: '+855', country: 'KH' },
  { code: '+856', country: 'LA' },
  { code: '+95', country: 'MM' },
  { code: '+673', country: 'BN' },
  { code: '+675', country: 'PG' },
  { code: '+679', country: 'FJ' },
  { code: '+682', country: 'CK' },
  { code: '+685', country: 'WS' },
  { code: '+686', country: 'KI' },
  { code: '+687', country: 'NC' },
  { code: '+688', country: 'TV' },
  { code: '+689', country: 'PF' },
  { code: '+690', country: 'TO' },
  { code: '+691', country: 'FM' },
  { code: '+692', country: 'MH' },
  { code: '+64', country: 'NZ' },
  { code: '+670', country: 'TL' },
  { code: '+672', country: 'NF' },
  { code: '+674', country: 'NR' },
  { code: '+676', country: 'NU' },
  { code: '+677', country: 'SB' },
  { code: '+678', country: 'VU' },
  { code: '+683', country: 'NU' },
  { code: '+685', country: 'WS' },
  { code: '+687', country: 'NC' },
  { code: '+689', country: 'PF' },
  { code: '+1', country: 'CA' },
  { code: '+1', country: 'JM' },
  { code: '+1', country: 'BB' },
  { code: '+1', country: 'BS' },
  { code: '+1', country: 'TT' },
  { code: '+1', country: 'GD' },
  { code: '+1', country: 'AG' },
  { code: '+1', country: 'DM' },
  { code: '+1', country: 'LC' },
  { code: '+1', country: 'VC' },
  { code: '+1', country: 'KN' },
  { code: '+1', country: 'BZ' },
  { code: '+506', country: 'CR' },
  { code: '+503', country: 'SV' },
  { code: '+502', country: 'GT' },
  { code: '+501', country: 'BZ' },
  { code: '+504', country: 'HN' },
  { code: '+505', country: 'NI' },
  { code: '+507', country: 'PA' },
  { code: '+591', country: 'BO' },
  { code: '+593', country: 'EC' },
  { code: '+594', country: 'GF' },
  { code: '+595', country: 'PY' },
  { code: '+598', country: 'UY' },
  { code: '+599', country: 'CW' },
  { code: '+54', country: 'AR' },
  { code: '+56', country: 'CL' },
  { code: '+57', country: 'CO' },
  { code: '+58', country: 'VE' },
  { code: '+51', country: 'PE' },
  { code: '+53', country: 'CU' },
  { code: '+55', country: 'BR' },
  { code: '+592', country: 'GY' },
  { code: '+597', country: 'SR' },
  { code: '+351', country: 'PT' },
  { code: '+351', country: 'PT' },
];

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    country_code: '+1',
    phone: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [detectedCountry, setDetectedCountry] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Fetch geolocation data
    const fetchGeoLocation = async () => {
      const geoData = await getGeoLocation();
      if (geoData && geoData.isSuccess) {
        setDetectedCountry(geoData.data.countryName);
      }
    };
    
    fetchGeoLocation();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await handleFormSubmission(formData);
      
      if (result.success) {
        toast.success(result.message || 'Thank you! Redirecting...');
        setFormData({ name: '', email: '', country_code: '+1', phone: '', subject: '', message: '' });
        
        // Redirect to application page with customer ID
        setTimeout(() => {
          window.location.href = result.redirectUrl;
        }, 1000);
      } else {
        toast.error(result.message || 'Submission failed. Please try again.');
      }
    } catch (error) {
      toast.error('An unexpected error occurred. Please try again.');
      console.error('Contact form error:', error);
    } finally {
      setLoading(false);
    }
  };

  const contactInfo = [
    {
      icon: <Mail className="h-6 w-6" />,
      title: 'Email Us',
      content: 'info@trademarklawconsulting.com',
      link: 'mailto:info@trademarklawconsulting.com',
    },
    {
      icon: <Phone className="h-6 w-6" />,
      title: 'Call Us',
      content: '+1 (877) 728-0539',
      link: 'tel:+18777280539',
    },
    {
      icon: <MapPin className="h-6 w-6" />,
      title: 'Visit Us',
      content: '585 Glenwood Ave, Menlo Park, CA 94025',
      link: null,
    },
  ];

  return (
    <div className="min-h-screen" data-testid="contact-page">
      <Helmet>
        <title>Contact Us - Trademark Law Consulting | Get Expert Trademark Help Today</title>
        <meta name="description" content="Contact Trademark Law Consulting for trademark registration questions. Call +1 (877) 728-0539 or email info@trademarklawconsulting.com. Fast response within 24 hours. Located in Washington, DC." />
      </Helmet>
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.pexels.com/photos/8112131/pexels-photo-8112131.jpeg"
            alt="Hero background"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-[#0A1C3E] opacity-90" />
        </div>
        <div className="container mx-auto px-4 md:px-6 relative z-10">
          <motion.div
            className="max-w-3xl mx-auto text-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-sm font-medium tracking-widest uppercase text-[#E1A334] mb-4 block">
              Get In Touch
            </span>
            <h1 className="text-5xl md:text-6xl font-heading font-bold text-white leading-tight mb-6">
              Contact Us
            </h1>
            <p className="text-lg text-slate-300 leading-relaxed">
              Have questions about our services? We're here to help. Reach out to our team and we'll get back to you as soon as possible.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {contactInfo.map((info, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-slate-50 rounded-2xl p-6 border border-slate-100 text-center"
              >
                <div className="bg-[#E1A334]/10 rounded-xl w-14 h-14 flex items-center justify-center text-[#E1A334] mx-auto mb-4">
                  {info.icon}
                </div>
                <h3 className="font-heading font-bold text-lg text-slate-900 mb-2">
                  {info.title}
                </h3>
                {info.link ? (
                  <a href={info.link} className="text-slate-600 hover:text-[#E1A334] transition-colors">
                    {info.content}
                  </a>
                ) : (
                  <p className="text-slate-600">{info.content}</p>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-12 md:py-20 bg-white">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-2xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-slate-100">
                <h2 className="text-3xl font-heading font-bold text-slate-900 mb-2">
                  Send Us a Message
                </h2>
                <p className="text-slate-600 mb-2">
                  Fill out the form below and we'll respond within 24 hours.
                </p>
                

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="space-y-2">
                    <Label htmlFor="contact-name">Name</Label>
                    <Input
                      id="contact-name"
                      data-testid="contact-name-input"
                      placeholder="Enter your full name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      required
                      className="h-12"
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="contact-email">Email</Label>
                    <Input
                      id="contact-email"
                      data-testid="contact-email-input"
                      type="email"
                      placeholder="your.email@example.com"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      required
                      className="h-12"
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="contact-phone">Contact Number</Label>
                    <div className="flex gap-2">
                      <Select
                        value={formData.country_code}
                        onValueChange={(value) => setFormData({ ...formData, country_code: value })}
                      >
                        <SelectTrigger className="w-[120px] h-12" data-testid="contact-country-select">
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          {countryCodes.map((country) => (
                            <SelectItem key={country.code} value={country.code}>
                              {country.code} ({country.country})
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                      <Input
                        id="contact-phone"
                        data-testid="contact-phone-input"
                        placeholder="123-456-7890"
                        value={formData.phone}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, '');
                          if (value.length <= 11) {
                            setFormData({ ...formData, phone: value });
                          }
                        }}
                        required
                        className="flex-1 h-12"
                        maxLength={11}
                        pattern="[0-9]*"
                        inputMode="numeric"
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="contact-subject">Subject</Label>
                    <Input
                      id="contact-subject"
                      data-testid="contact-subject-input"
                      placeholder="What is this regarding?"
                      value={formData.subject}
                      onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                      required
                      className="h-12"
                    />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="contact-message">Message</Label>
                    <Textarea
                      id="contact-message"
                      data-testid="contact-message-input"
                      placeholder="Tell us how we can help you..."
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                      rows={6}
                    />
                  </div>

                  <Button
                    type="submit"
                    disabled={loading}
                    data-testid="contact-submit-button"
                    className="w-full h-12 bg-[#E1A334] hover:bg-[#C4912E] text-white font-semibold rounded-full shadow-lg transition-all duration-300"
                  >
                    {loading ? 'Sending...' : 'Send Message'}
                  </Button>
                </form>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
